import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_OCCACTIMODELS = "occactimodels";
const BASE_URL = "/api/occactimodels";

const OccActimodelsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const OCCACTIMODELS_EMPTY = {
    provincie: "",
    sector: "",
    club: "",
    stamNr: "",

    secretarisNaam: "",
    secretarisVoornaam: "",
    secretarisStraat: "",
    secretarisNr: "",
    secretarisPostnr: "",
    secretarisGemeente: "",
    secretarisTelGsmFax: "",

    verantNaam: "",
    verantVoornaam: "",
    verantStraat: "",
    verantNr: "",
    verantPostnr: "",
    verantGemeente: "",
    verantTelGsmFax: "",

    datumActiv: "",
    locatieActiv: "",
    naamActiv: "",
    adresActiv: "",
    telGsmFaxActiv: "",
    omschrijvingActiv: "",

    datumDoorgegeven: "",
    verwerkt: ""

};

export function useOccActimodels() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_OCCACTIMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...OccActimodelsQueryConfig
    });
    return {...result, occactimodels: result.data};
}


export function useOccActimodel(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_OCCACTIMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...OccActimodelsQueryConfig
    });
    return {...result, occactimodel: result.data};
}

export function useOccActimodelMutations() {
    async function createFunction(occactimodel) {
        if (!occactimodel) return;
        return await fetchPOST(BASE_URL, occactimodel, false);
    }

    async function editFunction(occactimodel) {
        if (!occactimodel) return;
        return await fetchPUT(`${BASE_URL}/${occactimodel.id}`, occactimodel);
    }

    async function editAddNewFiles(occactimodel) {
        if (!occactimodel) return;
        return await fetchPUT(`${BASE_URL}/${occactimodel.id}/files`, occactimodel.fileId);
    }

    async function deleteFunction(occactimodel) {
        return await fetchDELETE(`${BASE_URL}/${occactimodel.id}`)
    }

    return {
        createOccActimodel: useMyMutation(createFunction, REACT_QUERY_ID_OCCACTIMODELS, occactimodel => `OccActimodel ${occactimodel.title} created`),
        editOccActimodel: useMyMutation(editFunction, REACT_QUERY_ID_OCCACTIMODELS, occactimodel => `OccActimodel ${occactimodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_OCCACTIMODELS, occactimodel => `OccActimodel ${occactimodel.title} modified`),
        deleteOccActimodel: useMyMutation(deleteFunction, REACT_QUERY_ID_OCCACTIMODELS, occactimodel => `OccActimodel ${occactimodel.title} deleted.`)
    };

}